import { render } from "./SignupForm.vue?vue&type=template&id=171d8ca4&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=ts"
export * from "./SignupForm.vue?vue&type=script&lang=ts"

import "./SignupForm.vue?vue&type=style&index=0&id=171d8ca4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-171d8ca4"

export default script